import { useCallback, useState } from 'react'

import type { ReactElement } from 'react'

import FeaturesTable from '../FeaturesTable'
import IapTable from '../IapTable'

import ContentLayout from '~/components/ContentLayout'
import Header from '~/components/Header/Classic'
import Layout from '~/components/Layouts/Layout'
import MwMLoader from '~/components/MwMLoader'
import ViewTitle from '~/components/ViewTitle'
import WorkflowGraph from '~/components/WorkflowGraph'
import useDocumentTitle from '~/hooks/useDocumentTitle'
import { useAppSummary } from '~/providers/AppSummary'
import { useAppSummaryDetailsQueryV2 } from '~/queries/applications'
import { useIapWorkflowGraphQuery } from '~/queries/iap'
import { transformByDeviceType } from '~/utils/application'
import { getIapResourceType } from '~/utils/iap'

import './styles.scss'

const GraphDetails = ({ appId, resourceId }: { appId: string; resourceId: string }): ReactElement | null => {
  const resourceType = getIapResourceType(resourceId)

  return resourceType === 'features' ? (
    <FeaturesTable appId={appId} resourceId={resourceId} />
  ) : resourceType === 'iaps' ? (
    <IapTable appId={appId} resourceId={resourceId} />
  ) : null
}

const IapGraph = (): ReactElement => {
  /** Local state */

  const [resourceId, setResourceId] = useState<string>()

  const { appDetails, appKey, deviceType } = useAppSummary()

  /** Queries & Mutationns */

  const { data: appSummary } = useAppSummaryDetailsQueryV2(appKey, deviceType)

  const { data: graph, isLoading } = useIapWorkflowGraphQuery({ appId: appSummary?.app_id })

  /** Effects */

  useDocumentTitle('IAP Graphs')

  /** Handlers */

  const handleGraphNodeClick = useCallback((id?: string) => setResourceId(id), [])

  /** Render */

  const appSelectorApp = appDetails ? transformByDeviceType(appDetails, deviceType) : undefined

  const isSwitchDisabled = !appDetails?.android || !appDetails?.ios

  return (
    <>
      <Header apps={appSelectorApp ? [appSelectorApp] : []} isSwitchDisabled={isSwitchDisabled} />
      <Layout className="iap-graph-view" withPadding>
        {isLoading ? (
          <MwMLoader category="item" />
        ) : (
          <>
            <ViewTitle className="layout-view-title">In-App purchases / Graph</ViewTitle>
            {graph ? (
              <WorkflowGraph className="iap-graph-view__graph" graph={graph} onNodeClick={handleGraphNodeClick} />
            ) : null}
            <ContentLayout>
              {appSummary && resourceId ? <GraphDetails appId={appSummary.app_id} resourceId={resourceId} /> : null}
            </ContentLayout>
          </>
        )}
      </Layout>
    </>
  )
}

export default IapGraph
